"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Just simple wrapper of remote FramePay api
 */

var remoteApi = function remoteApi() {
  // @ts-ignore
  return typeof window !== 'undefined' ? window.Rebilly : undefined;
};

function getRebillyApi() {
  return remoteApi();
}

exports.default = getRebillyApi;